// const API_FRONT ="http://localhost:3001";
const API_FRONT = process.env.REACT_APP_API_BACK || "https://backend.fmcadventistyouth.com";

/**
 * Génère une URL pour accéder aux fichiers directement depuis le backend
 * Utilise /uploads/ pour servir les fichiers (express.static)
 */
export function getFrontFileUrl(filePath) {
  if (!filePath) return "#";
  
  // Nettoyer le chemin
  let cleanPath = String(filePath).trim();
  
  // Si c'est déjà une URL complète, la retourner telle quelle
  if (cleanPath.startsWith("http://") || cleanPath.startsWith("https://")) {
    // Si l'URL contient /api/uploads/, corriger en /uploads/
    return cleanPath.replace(/\/api\/uploads\//g, "/uploads/");
  }
  
  // Enlever TOUS les préfixes possibles : /api/uploads/, /api/files/, /uploads/, uploads/, api/uploads/, etc.
  cleanPath = cleanPath.replace(/^\/?(api\/)?(uploads|files)\//i, "");
  
  // Normaliser les slashes multiples et enlever le slash initial
  cleanPath = cleanPath.replace(/\/+/g, "/").replace(/^\/+/, "");
  
  // Si le chemin est vide après nettoyage, retourner #
  if (!cleanPath) return "#";
  
  // Encoder chaque segment du chemin pour gérer les caractères spéciaux
  const segments = cleanPath.split("/").filter(s => s.length > 0);
  const encodedSegments = segments.map(segment => {
    try {
      // Décoder d'abord si déjà encodé (pour éviter double encodage)
      const decoded = decodeURIComponent(segment);
      // Puis réencoder correctement
      return encodeURIComponent(decoded);
    } catch {
      // Si le décodage échoue, encoder directement
      return encodeURIComponent(segment);
    }
  });
  
  // Construire l'URL finale directement vers /uploads/ (sans /api/)
  // Le backend sert /uploads/ directement via express.static
  const encodedPath = encodedSegments.join("/");
  const baseUrl = API_FRONT.replace(/\/$/, "").replace(/\/api$/, ""); // Enlever /api à la fin si présent
  return `${baseUrl}/uploads/${encodedPath}`;
}
